export enum FeatureFlag {
	EnableClientMgtCreateFolder = 'enable_client_mgt_create_folder',
	EnableUploadFromDeviceOption = 'enable_upload_from_device_option',
	EnableServiceTeamShareSuggestion = 'enable_serviceteam_share_suggestion',
	EnableClientMgtServiceTeamCreation = 'enable_client_mgt_service_team_creation',
}
